import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {AudioTranscriptionComponent} from './audio-transcription.component';
import {AudioRecordingModule} from "../../../../record/api/component/audio-recording/audio-recording.module";
import {LoadingModule} from "../../../../../../../components/common/loading/loading.module";
import {StickyContainerModule} from "../../../../../../core/component/sticky-container/sticky-container.module";
import {FormFieldModule} from "../../../../../../core/component/form-field/form-field.module";
import {ButtonModule} from "../../../../../../core/component/button/button.module";
import {AudioTranscriptionDialogComponent} from "../audio-transcription-dialog/audio-transcription-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        AudioRecordingModule,
        LoadingModule,
        StickyContainerModule,
        FormFieldModule,
        ButtonModule,
        AudioTranscriptionDialogComponent,
    ],
    declarations: [
        AudioTranscriptionComponent
    ],
    exports: [
        AudioTranscriptionComponent
    ],
})
export class AudioTranscriptionModule {
}
